import '../assets/js/express/controllers/clients_controller.es6';

import '../assets/js/express/controllers/open_ends_screenshots_controller.es6';
import '../assets/js/express/project/controllers/setup_controller.es6';
import '../assets/js/express/project/controllers/question_controller.es6';
import '../assets/js/express/project/controllers/config_swipe_controller.es6';
import '../assets/js/express/project/controllers/config_claims_controller.es6';
import '../assets/js/express/project/controllers/adding_naming_controller.es6';
import '../assets/js/express/project/controllers/adding_flavor_controller.es6';
import '../assets/js/express/project/controllers/details_naming_controller.es6';
import '../assets/js/express/project/controllers/config_concepts_test_controller.es6';
import '../assets/js/express/project/controllers/adding_adcept_controller.es6';
import '../assets/js/express/project/controllers/adding_package_controller.es6';
import '../assets/js/express/project/controllers/exercise_package_controller.es6';
import '../assets/js/express/project/controllers/video_ad_adcept_controller.es6';
import '../assets/js/express/project/controllers/details_concepts_test_controller.es6';
import '../assets/js/express/project/controllers/details_flavor_controller.es6';
import '../assets/js/express/project/controllers/details_package_controller.es6';
import '../assets/js/express/project/controllers/details_package_mc_controller.es6';
import '../assets/js/express/project/controllers/details_adcept_controller.es6';
import '../assets/js/express/project/controllers/full_page_controller.es6';
import '../assets/js/express/reports/controllers/wordcloud_screenshot_controller.es6';
import '../assets/js/express/directives/std_heatmaps.es6';
import '../assets/js/express/directives/std_markups.es6';
import '../assets/js/express/directives/std_wordclouds.es6';
import '../assets/js/express/services/swipe_popup_service.es6';
import '../assets/js/express/services/orientation_service.es6';
import '../assets/js/express/services/translation_service.es6';
import '../assets/js/express/services/paste_table_service.es6';
import '../assets/js/express/directives/swipe_popup.es6';
import '../assets/js/express/project/directives/image_uploader.es6';
import '../assets/js/express/project/directives/source_uploader.es6';
import '../assets/js/express/project/directives/next_button.es6';
import '../assets/js/express/project/directives/image_in_popup.es6';
import '../assets/js/express/directives/open_ends/express_word_cloud.es6';
import '../assets/js/express/directives/open_ends/express_open_end_card.es6';
import '../assets/js/express/directives/open_ends/express_language_switcher.es6';
import '../assets/js/express/directives/express_regions_mapper.es6';
import '../assets/js/express/directives/left_right_input.es6';

import '../assets/js/common_utils/download_manager/services/download_messaging.es6';
import '../assets/js/common_utils/download_manager/directives/download_popup.es6';
import '../assets/js/common_utils/directives/fancybox.es6';
import '../assets/js/common_utils/directives/sortable_header.es6';
import '../assets/js/common_utils/filters/html_safe.es6';
import '../assets/js/common_utils/directives/wysiwig-better.es6';
import '../assets/js/common_utils/components/modal_keywords.es6';
import '../assets/js/common_utils/services/font_loader.es6';
import '../assets/js/common_utils/directives/mouse_down.es6';
import '../assets/js/common_utils/directives/donut_chart.es6';
import '../assets/js/common_utils/directives/import_sheet_js.es6';
import '../assets/js/common_utils/directives/image_loaded.es6';
import '../assets/js/common_utils/directives/markups_v3.es6';
import '../assets/js/common_utils/directives/regions_mapper_settings.es6';
import '../assets/js/common_utils/directives/hint_in_popup.es6';
import '../assets/js/common_utils/filters/url_safe.es6';
import '../assets/js/common_utils/services/markup_tool.es6';

import '../assets/js/approach-react/common/render_dom.js';

$.fn.modal.Constructor.prototype.enforceFocus = function () {};
